"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@material-ui/core/styles");
var theme_1 = __importDefault(require("../../../../styles/theme"));
var makeStyles_1 = __importDefault(require("../../../../util/makeStyles"));
exports.default = (0, makeStyles_1.default)((0, styles_1.createStyles)({
    link: {
        lineHeight: theme_1.default.fonts.body.lineHeight,
        color: theme_1.default.colors.primary,
        '& > *': {
            color: theme_1.default.colors.primary,
        },
    },
    pointer: {
        cursor: 'pointer !important',
    },
}));
